import type { Menu } from '#/global'

import CouponMenu from './modules/coupon.menu'
import DouyinMenu from './modules/douyin.menu'
import MultilevelMenuExample from './modules/multilevel.menu.example'
import ToolsMenu from './modules/tools.menu'

/** 基于文件系统生成菜单 */
const menu: Menu.recordMainRaw[] = [
  {
    meta: {
      title: '演示',
      icon: 'uim:box',
    },
    children: [
      MultilevelMenuExample,
    ],
  },
  {
    meta: {
      title: '票券',
      icon: 'uim:box',
    },
    children: [
      ...CouponMenu,
    ],
  },
  {
    meta: {
      title: '工具',
      icon: 'uim:box',
    },
    children: [
      ...ToolsMenu,
    ],
  },
  {
    meta: {
      title: '抖音',
      icon: 'uim:box',
    },
    children: [
      ...DouyinMenu,
    ],
  },
]

export default menu
